import { render, staticRenderFns } from "./commissionRecord.vue?vue&type=template&id=846b7536&scoped=true"
import script from "./commissionRecord.vue?vue&type=script&lang=js"
export * from "./commissionRecord.vue?vue&type=script&lang=js"
import style0 from "./commissionRecord.vue?vue&type=style&index=0&id=846b7536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846b7536",
  null
  
)

export default component.exports